<template>
    <div class="tower-card" :style="{ borderColor: color.primary }">
        <div>
            <Cover :link="tower.link" :image="tower.image" :title="tower.title" />
        </div>
        <div class="tower-info" :style="{ background: `linear-gradient(90deg, transparent, ${ color.value + '1A' })` }">
            <div class="author" title="作者">{{ tower.author }}</div>
            <div v-if="tower.author2" title="复刻者">{{ tower.author2 }}</div>
            <div>通关: {{ tower.win }}</div>
            <div>游玩: {{ tower.people }}</div>
            <div class="tower-comment">
                [<a :href="dashboardLink" target="_blank"><span :style="{ color: color.primary }">{{ tower.comment }}</span>条评论</a>]
            </div>
        </div>
    </div>
</template>

<script>
import Cover from './Cover.vue'

import { COLORS } from '../constant'

export default {
    props: [ 'tower' ],
    computed: {    
        color() {
            return COLORS[this.tower.color];
        },
        dashboardLink() {
            return `/score.php?name=${ this.tower.name }`
        }
    },
    components: {
        Cover
    }
}
</script>

<style lang="less" scoped>
.tower-card {
    width: fit-content;
    padding-top: 0;
    padding-bottom: 0;
    margin-top: 10px;
    margin-bottom: 10px;
    border-radius: 2px;
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);
    border-left: 10px solid;
    border-bottom: none;
    display: flex;
}
.tower-info {
    width: 100px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    div {
        padding: 2px;
    }
    .tower-comment {
        margin-top: auto;
        align-self: flex-end;
    }
}
</style>